import {
  ChangeUserPassword,
  IEditUserPayload,
  IGetUserList,
  IUser,
  IUserCreate,
  IUserDetails,
  IUserListSearch,
  IUserLogin,
  UserProfileData,
} from "../../types/userInterface";
import { UserActionTypes, UserActions } from "../actionTypes/userActionTypes";

export const loginUser = (user: IUserLogin): UserActionTypes => ({
  type: UserActions.LOGIN_REQUEST,
  payload: user,
});

export const logoutUser = (): UserActionTypes => ({
  type: UserActions.LOGOUT_USER,
});

// Dispatch only when user login success
export const setUser = (user: IUser): UserActionTypes => ({
  type: UserActions.SET_USER,
  payload: user,
});

export const resetAllData = () => {
  return {
    type: UserActions.RESET_ALL_DATA,
  };
};

export const createUser = (user: IUserCreate): UserActionTypes => ({
  type: UserActions.CREATE_USER,
  payload: user,
});

export const getUserList = (payload: IUserListSearch) => ({
  type: UserActions.GET_USER_LIST,
  payload,
});

export const setUserList = (userList: Array<IGetUserList>): UserActionTypes => ({
  type: UserActions.SET_USER_LIST,
  payload: userList,
});

export const setUserListPageCount = (payload: number): UserActionTypes => ({
  type: UserActions.SET_USER_LIST_PAGE_COUNT,
  payload,
});

export const getUserDataById = (id: number | string) => ({
  type: UserActions.GET_USER_DATA_BY_ID,
  payload: id,
});

export const setUserDataById = (payload: IUserDetails) => ({
  type: UserActions.SET_USER_DATA_BY_ID,
  payload,
});

export const editUser = (payload: IEditUserPayload) => ({
  type: UserActions.EDIT_USER_DETAILS,
  payload,
});

export const getLoggedInUserData = () => ({
  type: UserActions.GET_LOGGEDIN_USER_DATA,
})

export const setLoggedInUserData = (payload: UserProfileData) => ({
  type: UserActions.SET_LOGGEDIN_USER_DATA,
  payload
})

export const changeUserPassword = (payload: ChangeUserPassword) => ({
  type: UserActions.CHANGE_USER_PASSWORD,
  payload
})